import { render, staticRenderFns } from "./inbodyDetail.vue?vue&type=template&id=c23858b2"
import script from "./inbodyDetail.vue?vue&type=script&lang=js"
export * from "./inbodyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23858b2')) {
      api.createRecord('c23858b2', component.options)
    } else {
      api.reload('c23858b2', component.options)
    }
    module.hot.accept("./inbodyDetail.vue?vue&type=template&id=c23858b2", function () {
      api.rerender('c23858b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/inbodyDetail.vue"
export default component.exports